var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-dialog",
    {
      ref: "modal",
      staticClass: "dialog",
      attrs: {
        name: _vm.modalName,
        "modal-props": _vm.sumModalProps,
        title: _vm.$t("chat.group-invitation-subject"),
      },
    },
    [
      _c("template", { slot: "default" }, [
        _c("div", { staticClass: "content-body" }, [
          _c(
            "div",
            { staticClass: "group-image" },
            [
              _c("icon-image", {
                staticClass: "big",
                attrs: { src: _vm.groupChatPhoto, text: _vm.groupChatName },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "group-name" }, [
            _vm._v(_vm._s(_vm.groupChatName)),
          ]),
          _c("div", { staticClass: "group-members" }, [
            _vm._v(
              _vm._s(_vm.$t("information.members-count")) +
                ": " +
                _vm._s(_vm.groupMembersCount)
            ),
          ]),
        ]),
      ]),
      _c(
        "template",
        { slot: "footer" },
        [
          _c("modal-btn", {
            attrs: { text: _vm.$t("cancel") },
            on: {
              click: function ($event) {
                return _vm.modalClose()
              },
            },
          }),
          _c("modal-btn", {
            attrs: { text: _vm.$t("chat.group-modal-confirm-text") },
            on: { click: _vm.joinGroupByLink },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }